import { Box, Icon, IconOptions, Loader, Spacer, Text } from '@jfs/ui-new'
import { useEffect } from 'react'
import { numberToLocalString } from '../../util/util'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import { styles } from './styles'

export const StatusReceiverType = {
  success: 'success',
  failure: 'failure',
  failed: 'failed',
  accepted: 'accepted',
  pending: 'pending',
  initiated: 'initiated',
  default: 'default',
  checkStatus: 'checkStatus',
  successfullWithCloseBtn: 'successfullWithCloseBtn',
}
interface StatusReceiverInterface {
  hide?: boolean
  type: keyof typeof StatusReceiverType
  isRefund?: boolean
  onRightButtonPress?: () => void
  amt?: number
  mainText?: string
  helperText?: string
  isLoading?: boolean
  autoDismiss?: boolean
  onDismiss?: () => void
  testID?: string
}

const getIconFromType = (type: string, amt: string, isRefund: boolean) => {
  let icon = 'TIMER',
    actionIcon = 'ARROW_RIGHT',
    amountText = 'Payment pending',
    color = 'ORANGE'

  switch (type) {
    case 'success':
      icon = 'LOGO'
      amountText = isRefund ? `₹ ${amt} Refunded` : `₹ ${amt} Received.`
      color = 'GREEN'
      break
    case 'accepted':
      icon = 'LOGO'
      amountText = isRefund ? `₹ ${amt} Refunded` : `₹ ${amt} Received.`
      color = 'GREEN'
      break
    case 'failure':
      icon = 'INFO'
      amountText = isRefund ? `Refund failed of ₹ ${amt}` : `Payment failed of ₹ ${amt}.`
      color = 'BRAND_PRIMARY_RED'
      break
    case 'failed':
      icon = 'INFO'
      amountText = isRefund ? `Refund failed of ₹ ${amt}` : `Payment failed of ₹ ${amt}.`
      color = 'BRAND_PRIMARY_RED'
      break
    case 'pending':
    case 'initiated':
      icon = isRefund ? 'INFO' : 'TIMER'
      actionIcon = isRefund ? 'ARROW_RIGHT' : 'ICON_REFRESH'
      amountText = isRefund ? `Refund of ₹ ${amt} is in Process` : `₹ ${amt} Pending from customer.`
      color = 'ORANGE'
      break
    case 'default':
      icon = ''
      actionIcon = 'ICON_REFRESH' // TODO: change icon id
      amountText = 'Check status of your payment.'
      color = 'BLUE'
      break
    case 'checkStatus':
      icon = ''
      actionIcon = ''
      amountText = 'Checking status of your payment...'
      color = 'BLUE'
      break
    case 'successfullWithCloseBtn':
      icon = 'ROUND_TICK'
      actionIcon = 'CLOSE'
      amountText = isRefund ? `₹ ${amt} Refunded` : `₹ ${amt} Received.`
      color = 'GREEN'
      break

    default:
      break
  }
  return { icon, actionIcon, amountText, color }
}

const StatusReceiver = ({
  hide = false,
  type = 'pending',
  onRightButtonPress,
  amt = 0,
  mainText = '',
  helperText = '',
  isRefund = false,
  isLoading = false,
  autoDismiss = false,
  onDismiss,
  testID,
}: StatusReceiverInterface) => {
  const isPending = (type === 'pending' || type === 'initiated') && !isRefund
  const isDefault = type === 'default' || type === 'checkStatus'
  const isSmallToast = type === 'successfullWithCloseBtn'
  const getProps = getIconFromType(type, numberToLocalString(Number(amt)), isRefund)

  useEffect(() => {
    const timeOut = 5000
    if (autoDismiss && !hide && StatusReceiverType.hasOwnProperty(type)) {
      const timeout = setTimeout(onDismiss ?? onRightButtonPress, timeOut)
      return () => clearTimeout(timeout)
    } else {
      return
    }
  }, [autoDismiss, hide, onDismiss, onRightButtonPress, type])

  if (hide || !StatusReceiverType.hasOwnProperty(type)) {
    return null
  } else {
    return (
      <Box
        {...styles.container(getProps.color, isSmallToast)}
        underlayColor="TRANSPARENT"
        testID="onRightButtonPress"
        onPress={onRightButtonPress}>
        <ModBox show={getProps.icon !== ''} {...styles.iconContainer}>
          <Icon id={getProps.icon as IconOptions} size={28} color="WHITE" />
        </ModBox>
        <ModBox {...styles.descriptionContainer(isDefault)} show={mainText.length < 1}>
          <Text type={isPending || isDefault ? 'h3' : 'h2Bold'} fontSize="SMALL" color="WHITE">
            {getProps.amountText}
          </Text>
          <Spacer size={3} />
          <Text
            hide={!isRefund && (isPending || isDefault)}
            type="h3Light"
            fontWeight="400"
            fontSize={12}
            color="WHITE">
            {'View Details'}
          </Text>
        </ModBox>
        <ModBox {...styles.descriptionContainer(isDefault)} show={mainText.length > 1}>
          <Text color="WHITE" fontWeight="bold" testID={testID}>
            {mainText}
          </Text>
          {!!helperText && (
            <>
              <Spacer size={3} />
              <Text type="h4Light" fontWeight="400" color="VISIBLE_WHITE">
                {helperText}
              </Text>
            </>
          )}
        </ModBox>
        <ModBox
          onPress={onRightButtonPress}
          testID={'onRightButtonPress'}
          {...styles.iconContainer}
          show={(mainText.length < 1 && !isLoading) || isSmallToast}>
          <Icon id={getProps.actionIcon as IconOptions} color="WHITE" size={22} />
        </ModBox>
        <ModBox {...styles.iconContainer} show={type === StatusReceiverType.checkStatus || isLoading}>
          <Loader color={'WHITE'} />
        </ModBox>
      </Box>
    )
  }
}

export { StatusReceiver }
